import { Component } from '@mycolorway/tao';
import flatpickr from 'next/javascripts/modules/flatpickr';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';

export default Component('tr-date-range-field', {
  mixins: [eventListenerMixin],

  properties: {
    displayFormat: {
      type: String,
      default: 'Y-m-d',
    },

    valueFormat: {
      type: String,
      default: 'Y-m-d',
    },

    hasShortcuts: {
      type: Boolean,
      default: false,
    },

    disabled: {
      type: Boolean,
      default: false,
      observer() {
        if (this.hasShortcuts) {
          this.nativeField.disabled = this.disabled;
        } else {
          this.dateField.disabled = this.disabled;
        }
      },
    },
  },

  ready() {
    if (this.hasShortcuts) {
      this.nativeField = this.querySelector('input.native-control');
      this.shortcutsSelect = this.querySelector('tr-combo-select-field');
      this.selectFieldResult = this.shortcutsSelect.result;
      this.initFlatpickr();
      this.addEventListeners();
    } else {
      this.dateField = this.querySelector('tr-date-field');
    }
  },

  disconnected() {
    if (this.datePicker) this.datePicker.destroy();
    this.stopListening();
  },

  initFlatpickr() {
    const defaultDate = (this.nativeField.value || '').split(/,\s?/).filter(s => !!s);
    const config = {
      animate: false,
      mode: 'range',
      dateFormat: this.valueFormat,
      defaultDate: defaultDate.length === 2 ? defaultDate : [],
      wrap: true,
      onClose: this.handleDatePickerClosed.bind(this),
    };

    this.datePicker = flatpickr(this, config);
    if (defaultDate.length === 2) this.setSelectedDate(this.datePicker.selectedDates);
  },

  addEventListeners() {
    this.listenTo(this.shortcutsSelect, {
      'tr-combo-select-field:change': this.handleShortcutsSelected.bind(this),
      'tr-combo-select-field:menuClosed': this.handelShortcutsMenuClosed.bind(this),
    });
  },

  setSelectedDate(dates) {
    if (dates && dates.length === 2) {
      this.nativeField.value = dates
        .map(date => flatpickr.formatDate(date, this.valueFormat))
        .join(',');

      const dateStr = dates
        .map(date => flatpickr.formatDate(date, this.displayFormat))
        .join(this.datePicker.l10n.rangeSeparator);
      this.setShortcutsSelectResultText(dateStr);
    } else {
      this.nativeField.value = null;
      this.shortcutsSelect.reset();
    }
  },

  setShortcutsSelectResultText(text) {
    this.selectFieldResult.resultWrapper.querySelector('.result').textContent = text;
  },

  handleShortcutsSelected(event) {
    const value = event.detail;

    if (value === 'custom') {
      this.nativeField.value = null;
      this.setShortcutsSelectResultText('');
      this.datePicker.setDate([]);
      setTimeout(() => this.datePicker.open(), 0);
    } else {
      this.nativeField.value = value;
    }

    this.notifyChange();
  },

  setValue(value) {
    this.nativeField.value = value;
  },

  handelShortcutsMenuClosed() {
    if (this.shortcutsSelect.getValue() === 'custom') {
      this.selectFieldResult.active = this.datePicker.isOpen;
    }
  },

  handleDatePickerClosed(selectedDates) {
    this.setSelectedDate(selectedDates);
    this.notifyChange();
    this.selectFieldResult.active = false;
  },

  notifyChange() {
    let selectedValue;

    if (this.hasShortcuts) {
      selectedValue = this.nativeField.value;
    } else {
      selectedValue = this.dateField.nativeField.value;
    }

    this.namespacedTrigger('change', {
      detail: selectedValue,
      bubbles: true,
    });
  },

  reset() {
    if (this.hasShortcuts) {
      this.selectFieldResult.active = false;
      this.shortcutsSelect.reset();
    } else {
      this.dateField.clearSelected();
    }
    this.nativeField.value = null;
  },

  layout() {
    if (this.selectFieldResult) this.selectFieldResult.layout();
    if (this.dateField) this.dateField.layout();
  },
});
